/* Just Add Baking — scroll reveal utility.
   Adds .is-visible to any .reveal element once it scrolls into view.
   Shared by hero, oven-scene, how-it-works, photo-showcase, and highlights
   sections. Safe to run once per page load; re-runs harmlessly if a section
   is added/removed via the theme editor (uses event delegation via a fresh
   querySelectorAll + observer each time this file executes, and Shopify
   re-renders the whole DOM on section load in the editor). */
(function () {
  function initReveal() {
    var revealEls = document.querySelectorAll('.reveal:not([data-reveal-bound])');
    if (!revealEls.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0 }
    );

    revealEls.forEach(function (el) {
      el.setAttribute('data-reveal-bound', 'true');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-scan when Shopify's theme editor injects/reloads a section.
  document.addEventListener('shopify:section:load', initReveal);
})();
